import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">专题聚焦</h2>
          <p className="text-foreground-600 text-sm">深度专题内容，发现更多精彩</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="relative rounded-2xl overflow-hidden cursor-pointer group h-[320px] md:h-[380px]"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-black/10"></div>

              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500 text-background-50 mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-xl md:text-2xl font-bold text-background-50 mb-2">{item.title}</h3>
                <p className="text-sm text-background-200/80 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}